<template>
  <div class="">
    <Breadcrumb :title="$t('miga.InOfficeFlow')" />
    <HeadingBox
      v-if="!ticket"
      :title="$t('selectservice.title')"
      :description="$t('selectservice.description')"
    />
    <HeadingBox
      v-if="ticket"
      :title="$t('confirmation.title')"
      :description="$t('rgpd.hinfoadicional')"
    />

    <DatosIntroducidos />

    <AlertaError />
    <Spinner v-show="loading" />
    <ListBox
      v-if="!ticket"
      :heading="$t('selectservice.title')"
      :loading="loading"
      :items="services"
      title="name"
      description="description"
      icons_attribute="icons"
      :onSelect="onSelect"
    />

  </div>
</template>
<script>
import Vue from 'vue';
import Breadcrumb from "@/components/Breadcrumb";
import HeadingBox from "@/components/HeadingBox";
import DatosIntroducidos from "../components/DatosIntroducidos";
import ListBox from "../components/ListBox";
import AlertaError from "@/components/AlertaError.vue";
import Spinner from "@/components/Spinner.vue";

import APIPortal from "@/services/APIPortal.js";
import Utils from "@/services/Utils.js";
import Session from "@/session/Session.js";

/**
 * Todo esto funciona a traves del codigo QR. Si el codigo incluye el canal
 * presencial:
 * - No se piden datos personales
 * - se busca el primer slot automaticamente
 * - si el slot debe esperar menos de 15 minutos, se emite la cita directamente.
 * - en caso de que no hubiera hueco, se prosigue el flujo normal y se piden los datos. *
 */
export default {
  name: "SelectService",
  components: {
    AlertaError,
    Spinner,
    Breadcrumb,
    HeadingBox,
    DatosIntroducidos,
    ListBox
  },
  data: () => ({
    queue: Session.getQueue(),
    services: [],
    loading: false,
    ticket: null
  }),
  beforeDestroy() {
    window.removeEventListener('language.changed', this.init);
  },

  async mounted() {
    window.addEventListener("language.changed", () => Vue.nextTick(this.init));
    this.init();
  },

  methods: {
    async init () {
      window.console.log('inoffice flow', Session.getQueue())
      this.services.splice(0, this.services.length)
      this.loading = true
      let res = await APIPortal.servicepointbyQueue(Session.getQueue().id, "m");
      this.services = res.data
        .filter((s) => s.supportsAppointments)
        .filter((s) => s.enPlazoSolicitud);

      this.services = window._.sortBy(this.services, ["name"], ["asc"]);

      window._.each(this.services, (s) => {
        s.icons = [];
        if (s.supportsOffice) s.icons.push("fas fa-people-arrows");
        if (s.supportsCallMe) s.icons.push("fa fa-phone");
        if (s.supportsVideoconference) s.icons.push("fa fa-tv");
      });
      this.loading = false
    },
    async onSelect(s) {
      Session.setServicePoint(s);

      let slots = (await APIPortal.findSlots(Session.getQueue().id, s.id, Utils.ATTENCION_OFICINA)).data || [];
      window.console.log('slots>', slots)
      if (!slots.length) {
        return this.$router.push({ name: 'SelectChannel' });
      }
      let tentativeSlot = slots[0]
      let waitTimeInSeconds = (new Date(tentativeSlot).getTime() - new Date().getTime()) / 1000;
      let waitTimeInMinutes = waitTimeInSeconds / 60
      window.console.log('tentativeSlot>', tentativeSlot, new Date(tentativeSlot) )
      window.console.log(`waitTime> ${waitTimeInSeconds}s ${waitTimeInMinutes}m`, )

      if (waitTimeInMinutes > 15) {
        return this.$router.push({ name: 'SelectChannel' });
      }

      this.issueTicket(tentativeSlot)
    },
    async issueTicket(slot) {
      var t = {
          queue: { id: Session.getQueue().id },
          servicePoint: { id: Session.getServicePoint().id },
          issueChannel: { id: Utils.PORTAL_CHANNEL },
          serviceChannel: { id: Utils.ATTENCION_OFICINA },
          scheduledServiceTime: slot,
          checkInTime: new Date(),
          visitorName: 'visitante QR oficina sin identificar',
          comments: Session.getComments()
      };

      try {
        this.loading = true;
        let res = await APIPortal.issueTicket(t);
        this.loading = false;
        Utils.muestraTicketEmitido(res.data)
      } catch (e) {
        this.loading = false;
        window.console.log("err>", e);
      }
    },
  },
};
</script>

<style scoped>
</style>
